<script>
  export let label = "Unlabeled";
  export let size = "";
  export let type = "";
  export let clickFn = () => {};
</script>

<button
  class:lg={size === "lg"}
  class:orange={type === "orange"}
  class:green={type === "green"}
  class:red={type == "red"}
  on:click={clickFn}
>
  {label}
</button>

<style>
  button {
    font-family: "Inter", sans-serif;
    background-color: #f5f5f7;
    display: block;
    border: none;
    padding: 1.2rem 1rem;
    border-radius: 1rem;
    color: #8888a1;
    font-size: 1.4rem;
    font-weight: 600;
    cursor: pointer;
  }

  .lg {
    width: 100%;
    padding: 2rem;
    text-align: center;
    font-size: 1.6rem;
  }

  .orange {
    background-color: #fe5900;
    color: #fff;
  }

  .green {
    background-color: #1dab56;
    color: #fff;
  }

  .red {
    background-color: #ca1010;
    color: #fff;
  }
</style>
